import { cacheDom } from '../utils/QuerySelectors.js'
import { closeDialog, openDialog } from '../utils/dialogHelper.js'

const dom = {}
let openerEl = null
const qs = {
  modal: 'data-popup',
  wrapper: 'data-popup-wrapper',
  content: 'data-popup-content',
  close: 'data-popup-close',
}
const qsAll = {}
const state = {
  closeCallback: null,
}

const setDialogLabel = () => {
  const heading = dom.content.querySelector('h1, h2, h3, h4, h5, h6')
  if (!heading) return
  if (!heading.id) heading.id = 'popup-dialog-title'
  dom.wrapper.setAttribute('aria-labelledby', heading.id)
  dom.wrapper.removeAttribute('aria-label')
}

const closePopup = () => {
  const closeCallback = state.closeCallback
  state.closeCallback = null
  if (closeCallback) closeCallback()
  closeDialog(openerEl)
  openerEl = null
  toggleModal(false)
}

const toggleModal = (toggle = true, content = null, node = null, clear = true) => {
  if (clear) dom.content.innerHTML = ''
  if (content) dom.content.innerHTML = content
  if (!content && node) dom.content.appendChild(node)
  dom.modal.classList.toggle('!flex', toggle)
  dom.modal.classList.toggle('z-[-1]', !toggle)
  dom.modal.classList.toggle('opacity-0', !toggle)
  dom.modal.classList.toggle('z-30', toggle)
  dom.modal.classList.toggle('opacity-100', toggle)
  document.body.classList.toggle('overflow-hidden', toggle)
  if (dom.content.querySelector('video')) dom.content.querySelector('video').pause()

  if (toggle) {
    setDialogLabel()
    openerEl = document.activeElement instanceof HTMLElement ? document.activeElement : null
    openDialog(dom.wrapper, openerEl, {
      onClose: closePopup,
    })
  } else {
    dom.wrapper.removeAttribute('aria-labelledby')
    dom.wrapper.setAttribute('aria-label', 'Wishlist')
  }
}

export const setupPopup = () => {
  cacheDom(dom, qs, qsAll)

  window.openPopup = (modalContent, modalNode = null, closeCallback = null) => {
    state.closeCallback = closeCallback
    toggleModal(true, modalContent, modalNode)
  }

  dom.close.addEventListener('click', () => {
    closePopup()
  })
  dom.wrapper.addEventListener('click', (e) => {
    e.stopPropagation()
  })
  dom.modal.addEventListener('click', () => {
    closePopup()
  })
}
